/**
 * @desc 补充物流订单非必填信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.TransportNotRequiredRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/notRequiredTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
